import { Injectable, Injector } from '@angular/core';
import { AngularFirestore, AngularFirestoreCollection } from 'angularfire2/firestore';
import * as firebase from 'firebase';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import { Constants } from '../app.constant';
import { NotificationService } from "./notification.service";
import { ToasterService } from 'angular2-toaster';
import { WebNotification, NonSlientMessageTypes } from '../pages/shared/components/notification/models/notification'

@Injectable()
export class FcmMessagingService {

  private isMessageOnce: boolean = false;
  private messaging;

  private messageSource = new Subject()
  currentMessage = this.messageSource.asObservable()
  private afs;
  constructor (
    // private afs: AngularFirestore, 
    private injector: Injector,
    private toasterService: ToasterService, 
    private notificationService: NotificationService
  ) {
    if(Constants.Var.sslOn){
      this.afs = this.injector.get(AngularFirestore);      
      this.messaging = (Constants.Var.sslOn) ? firebase.messaging() : null;
    }

  }

  /** Get permission from browser to send messages, save token in api-db, save token in cookies. */
  getPermission() {
    if (typeof Notification != 'undefined') {
      this.messaging.requestPermission()
        .then(() => {
          return this.messaging.getToken();
        })
        .then(token => {
          this.saveToken(token);
        })
        .catch((err) => {
          console.log('Unable to get permission to notify.', err);
        });
    }
  }

  // Listen for token refresh
  monitorRefresh() {
    this.messaging.onTokenRefresh(() => {
      this.messaging.getToken()
        .then(refreshedToken => {
          // console.log('Token refreshed.');
          // this.saveToken(refreshedToken)
        })
        .catch(err => console.log(err, 'Unable to retrieve new token'))
    });
  }

  // used to show message when app is open
  receiveMessages() {
    if (this.isMessageOnce != true) {
      this.isMessageOnce = true;
      this.messaging.onMessage((payload: any) => {
        this.messageSource.next(payload);
        if (payload && payload.data.result != null) {
          let response=this.convertToJSON(payload.data.result);
          this.isKeyExist(NonSlientMessageTypes, response.messageType).subscribe(res => {
            if (res == true) {
              this.notificationService.prependValue(new WebNotification(response));
              this.toasterService.pop('info', 'New Message', response.messageTitle);
            }
          })
        }
      });
    }
  }

  /**
  *  Listen to firebase messages depending upon keys
  *  https://medium.com/front-end-hacking/being-rxjs-subjects-savvy-4aec5c8da99e
  *  https://blog.angularindepth.com/rxjs-how-to-use-refcount-73a0c6619a4e
  *  https://blog.angularindepth.com/rxjs-understanding-the-publish-and-share-operators-16ea2f446635
  *  https://blog.angularindepth.com/rxjs-how-to-use-refcount-73a0c6619a4e
  *  https://stackoverflow.com/questions/38950435/rxjs-resubscribe-to-unsubscribed-observable?utm_medium=organic&utm_source=google_rich_qa&utm_campaign=google_rich_qa
  */
  receiveMessageByKey(keys: Array<string>): Observable<any> {
    //----------4444----------
    // return this.messageSource.filter((payload: any): boolean => {
    //   console.log('receiveMessageByKey -', payload)
    //   let isValid = true
    //   if (payload && payload.data != null && payload.data.messageType != null) {
    //     this.isKeyExist(keys, payload.data.messageType).subscribe(res => {
    //       if (res == true) return payload.data;
    //     })
    //   }
    //   return isValid;
    // })
    //----------3333----------
    // return this.messageSource.map((payload: any) => {
    //   console.log('ByKey -messageSource.map -', payload)
    //   if (payload && payload.data != null && payload.data.messageType != null) {
    //     this.isKeyExist(keys, payload.data.messageType).subscribe(res => {
    //       if (res == true) return payload.data;
    //     })
    //   }
    // })
    //----------2222----------
    return Observable.create(observer => {
      this.messageSource.asObservable().subscribe((payload: any) => {
        console.log("Ankit >> receiveMessageByKey: ", payload);
        if (payload && payload.data.result != null) {
          let response=this.convertToJSON(payload.data.result);
          this.isKeyExist(keys, response.messageType).subscribe(res => {
            if (res == true) observer.next(response);
          })
        }
      })
      return () => {
          
          // this.messageSource.unsubscribe()
          // this.messageSource.complete()
      };
    })
    //----------1111----------
    // return Observable.create(observer => {
      // this.messaging.onMessage((payload: any) => {
      //   console.log('receiveMessageByKey -', payload)
      //   if (payload && payload.data != null && payload.data.messageType != null) {
      //     this.isKeyExist(keys, payload.data.messageType).subscribe(res => {
      //       if (res == true) observer.next(payload.data);
      //     })
      //   }
      // });
    // })
  }

  isKeyExist(keys: Array<string>, messageType: any): Observable<boolean> {
    let messageTypeList = Constants.NotificationConfigKeysInformations();
    return Observable.create(observer => {
      let isExist: boolean = false;
      let messageTypeKey;
      if (keys && keys.length > 0 && messageType != null) {
        messageTypeKey = Object.keys(messageTypeList).find(key => messageTypeList[key] == messageType)
        isExist = keys.indexOf(messageTypeKey) > -1
      }
      observer.next(isExist)
      observer.complete()
    })
  }

  // save the permission token in firestore
  private saveToken(token: string): void {
    let oldToken = Constants.CurrentFirebaseInformations('token')
    // If token is new and not save in db, update db
    if (token && token != oldToken) {
      this.notificationService.webTokenRegistration(token).subscribe(res => { })
      Constants.resetFirebase({ token: token })
    }
  }

  convertToJSON(str) {
    try {
      var obj = JSON.parse(str);
      if (obj && typeof obj === 'object' && obj !== null) {
        return obj;
      }
      else {
        return null;
      }
    } catch (err) {}
  }
}


// WEBPACK FOOTER //
// ./src/app/services/fcm-messaging.service.ts